import { useEffect, useRef, useState } from 'react';

const SUPPORT_EMAIL = 'support@insightpm.one';
const MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('InsightPM support')}`;

export default function SupportMenu() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDocMouseDown = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('mousedown', onDocMouseDown);
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('mousedown', onDocMouseDown);
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
    } catch {
      // Fallback for insecure contexts / older browsers — clipboard API needs
      // a secure origin, so on http or in some embedded webviews it throws.
      const ta = document.createElement('textarea');
      ta.value = SUPPORT_EMAIL;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
      } catch {
        // best-effort; user can still select text manually
      }
      document.body.removeChild(ta);
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="support-wrap" ref={wrapRef}>
      <button
        type="button"
        className="btn btn-ghost block"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(v => !v)}
      >
        Support
      </button>

      {open && (
        <div className="support-popover" role="dialog" aria-label="Contact support">
          <div className="support-popover-title">Need help?</div>
          <p className="muted small support-popover-lede">
            Reach our team at the email below — we usually reply within one business day.
          </p>
          <div className="support-email" title="Support email">
            {SUPPORT_EMAIL}
          </div>
          <div className="support-actions">
            <button type="button" className="btn btn-ghost" onClick={handleCopy}>
              {copied ? 'Copied' : 'Copy email'}
            </button>
            <a className="btn btn-primary" href={MAILTO}>
              Compose email
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
